<div class="time-range">
  <div class="start-time">{{ lesson.timeStart < 10 && '0' + lesson.timeStart || lesson.timeStart }}:00</div>
  <div class="end-time">{{ lesson.timeEnd < 10 && '0' + lesson.timeEnd || lesson.timeEnd }}:00</div>
</div>
<div class="main-info">
  <app-text-with-tooltip class="name" [text]="lesson.name" />

  <div class="additional-info">
    <div class="ellipsis-text info-item-wrap">
      <div class="info-item">{{ lesson.type }}</div>
      <div *ngIf="lesson.online || lesson.hybrid" class="info-item info-item-type">
        <a *ngIf="lesson.online" href="#" class="info-link">{{onlineClassText}}</a>
        <a *ngIf="lesson.hybrid" href="#" class="info-link">{{hibridClassText}}</a>
      </div>
    </div>

    <div *ngIf="lesson.location && !lesson.online" class="ellipsis-text info-item info-item-location">
      <span *ngIf="lesson.gpsX && lesson.gpsY">
        <a class="info-link" (click)="locatinPicker.openMapsModal()">
          <mat-icon [svgIcon]="'location-2'" class="square-icon location-icon"></mat-icon>
          <span class="location-text">{{ lesson.location }}</span>
        </a>
      </span>
      <span *ngIf="!lesson.gpsX || !lesson.gpsY">
          <mat-icon [svgIcon]="'location-2'" class="square-icon location-icon"></mat-icon>
          <span class="location-text">{{ lesson.location }}</span>
      </span>
    </div>
  </div>
</div>

<app-location-select-picker #locatinPicker [gpsX]="lesson.gpsX" [gpsY]="lesson.gpsY" />